import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import {IconButton, Typography, useMediaQuery, useTheme} from '@mui/material';
import {useApplicationTemplates} from '@ozark/common';
import {Loading, Title} from '@ozark/common/components';
import React from 'react';
import {useHistory} from 'react-router-dom';
import {useStore} from '../../store/helpers';
import {PricingTemplate} from './PricingTemplate';

const PricingTemplatesPage = () => {
  const {authProfile} = useStore();
  const history = useHistory();
  const theme = useTheme();

  const smDown = useMediaQuery(theme.breakpoints.down('md'));

  const {applicationTemplates} = useApplicationTemplates(authProfile?.data?.id);
  const [whichExpanded, setWhichExpanded] = React.useState<string | false>(false);

  const handleExpandChange =
    (panel: string) => (_event: React.ChangeEvent<{}>, isExpanded: boolean) => {
      setWhichExpanded(isExpanded ? panel : false);
    };

  const getApplicationTemplatesAsArray = () =>
    !applicationTemplates.promised && applicationTemplates.data ? applicationTemplates.data : [];

  const getTemplates = () => {
    return getApplicationTemplatesAsArray().map(template => (
      <PricingTemplate
        key={template.templateName}
        onChange={handleExpandChange}
        whichExpanded={whichExpanded}
        template={template}
        onSubmit={() => setWhichExpanded(false)}
      />
    ));
  };

  if (!authProfile.data || applicationTemplates.promised) return <Loading />;

  return (
    <div>
      <Title
        breadcrumbs={
          smDown
            ? [
                <IconButton onClick={() => history.goBack()} size="large">
                  <ChevronLeftIcon />
                </IconButton>,
              ]
            : [
                <Typography variant="body1">
                  <span style={{textTransform: 'capitalize'}}>Pricing Templates</span>
                </Typography>,
              ]
        }
      ></Title>
      {getTemplates()}
    </div>
  );
};

export default PricingTemplatesPage;
